<script>
import { layoutComputed } from "@/store/helpers";

import Vertical from "./vertical.vue";
import Horizontal from "./horizontal.vue";
import TwoColumns from "./twocolumn.vue";
import ChatContainer from "../components/ChatContainer.vue";

export default {
  components: {
    Vertical,
    Horizontal,
    TwoColumns,
    ChatContainer,
  },
  data() {
    return {
      blacklistInternalPageOn: ["auth.workspace", "omni.conversation.chat"],
    };
  },
  computed: {
    ...layoutComputed,
    isLoading() {
      if (this.$route.path.split("/")[2] != "dashboard") {
        return this.$store.getters["loading/isLoading"];
      } else {
        return false;
      }
    },
    assignedChannel() {
      return this.$store.getters["agent/assignedChannel"];
    },

    checkBlacklistInternalChat() {
      return (
        this.blacklistInternalPageOn.findIndex(
          (r) => r === this.$route.name
        ) === -1
      );
    },
  },
  beforeCreate() {
    if (this.$store.getters.appId.decoded) {
      this.$store.dispatch("agent/assignedChannel");
    }
    // this.$store.dispatch("agent/updateOnline", {
    //   state: "online",
    //   // online: true,
    // });
  },
  created() {
    window.onresize = () => {
      this.$store.commit("UPDATE_WIDTH");
    };
  },
};
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>

    <TwoColumns v-if="layoutType === 'twocolumn'" :layout="layoutType">
      <slot />
    </TwoColumns>

    <ChatContainer v-if="checkBlacklistInternalChat" />
  </div>
</template>
